/* eslint-disable @typescript-eslint/naming-convention */
import {
    Component, Input, Output, OnInit, EventEmitter, ViewChild, AfterViewInit
} from '@angular/core';

import { HisSearchFormResultComponent } from 'hisng';

import { PublicationCreator } from 'app/fs/res/publication/model/publication-creator';
import { Person } from 'app/fs/res/common/model/person/person';


@Component( {
    selector: 'res-publication-creator-wizard-person',
    templateUrl: './publication-creator-wizard-person.component.html',
} )
export class PublicationCreatorWizardPersonComponent implements OnInit, AfterViewInit {
    @Input() creator: PublicationCreator;
    @Input() originalCreator: PublicationCreator;
    @Output() selectionSubmit = new EventEmitter();

    presetInputFields: Record<string, string>;

    selectedOptions: any[];

    @ViewChild( HisSearchFormResultComponent, { static: false } ) searchFormResultComponent: HisSearchFormResultComponent;


    ngOnInit() {
        if ( !this.creator.creatorOrganizations ) {
            this.creator.creatorOrganizations = [];
        }
        this.presetInputFields = {
            'Person.surname': this.creator.creatorname?.trim().replace( /\.$/, '' ),
            'Person.firstname': this.creator.firstname?.trim().replace( /\.$/, '' ),
            'Person.nameprefix': this.creator.nameprefix?.trim().replace( /\.$/, '' ),
            'Person.namesuffix': this.creator.namesuffix?.trim().replace( /\.$/, '' ),
        };
    }

    ngAfterViewInit() {
        this.searchFormResultComponent.submitInitialSearch();
    }

    setPerson( event: any[] ) {
        let result = event[0];
        let person = new Person(
            result['Person.id'],
            result['Person.surname'],
            result['Person.firstname'],
            result['Person[GenderValue].defaulttext'] );
        this.creator.person = person;
        this.creator.orcid = result[
            'Person.personOrcidIdentifiers.identifier']?.split( ',' );
        this.selectionSubmit.emit();
    }

    selectNoInternalPerson() {
        console.log( 'no internal person selected' );
        this.creator.person = null;
        this.selectionSubmit.emit();
    }
}
